import { restClient } from '../rest-client';

export const cmsApi = {
  getBanner(url: string) {
    return restClient.get<Blob>(url, { responseType: 'blob' });
  },
};
